module.exports = __webpack_public_path__ + "static/media/front_active.5e047899.svg";